import { Button, Text, Group } from "@mantine/core";
import React, { useState } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { showNotification } from "@mantine/notifications";
import { openFileUrl } from "../utils/openReport";

const ReportActivityLog = ({}) => {
  const [fromDate, setFromDate] = useState(() =>
    moment().subtract(30, "days").startOf("day").toDate()
  );
  const [toDate, setToDate] = useState(() => moment().endOf("day").toDate());
  const [loading, setLoading] = useState(false);

  const [api] = useServerApi();
  const { t } = useTranslation();

  const canDownload = Boolean(fromDate && toDate);

  const downloadReport = async () => {
    if (!fromDate || !toDate) {
      showNotification({
        color: "red",
        message: t("Please select both From and To dates for the activity log report."),
      });
      return;
    }

    try {
      setLoading(true);
      const result = await api.ActivityLog.getReport({ fromDate, toDate });
      setLoading(false);

      if (result?.success === false) {
        showNotification({
          color: "red",
          message: result.message || t("Failed to download report."),
        });
        return;
      }

      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "Please select the From and To dates for the activity log report. Both dates are required."
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          required
          value={fromDate}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          required
          value={toDate}
          onChange={(d) => setToDate(d)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportActivityLog;
